import { API_BASE } from '../../../config/api';

const buildHeaders = (token, includeJson = false) => ({
  ...(includeJson ? { 'Content-Type': 'application/json' } : {}),
  Authorization: `Bearer ${token}`,
});

const parseResponse = async (response, fallbackMessage) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || payload.message || fallbackMessage);
  }
  return payload;
};

export const fetchSuperAdminStats = async (token) => {
  const response = await fetch(`${API_BASE}/api/superadmin/stats`, {
    cache: 'no-store',
    headers: buildHeaders(token),
  });

  return parseResponse(response, 'Unable to load super admin stats.');
};

export const fetchRegistrationSettings = async (token) => {
  const response = await fetch(`${API_BASE}/api/superadmin/settings/registrations`, {
    cache: 'no-store',
    headers: buildHeaders(token),
  });

  return parseResponse(response, 'Unable to load registration settings.');
};

export const updateRegistrationSettings = async ({ enabled, token }) => {
  const response = await fetch(`${API_BASE}/api/superadmin/settings/registrations`, {
    method: 'PATCH',
    headers: buildHeaders(token, true),
    body: JSON.stringify({ enabled }),
  });

  return parseResponse(response, 'Unable to update registration settings.');
};
